import { render } from "./AppDialog.vue?vue&type=template&id=6ed62d38&scoped=true"
import script from "./AppDialog.vue?vue&type=script&lang=js"
export * from "./AppDialog.vue?vue&type=script&lang=js"

import "./AppDialog.vue?vue&type=style&index=0&id=6ed62d38&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ed62d38"]])

export default __exports__